import isEmpty from 'lodash.isempty'

function buildParamList(params) {
  if (isEmpty(params)) return ''
  try {
    let returnedParams = '?'
    if (typeof params === 'object') {
      const allParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (Array.isArray(value)) {
          acc.push(`${key}=${value.join()}`)
        } else {
          acc.push(`${key}=${value}`)
        }
        return acc
      }, [])
      returnedParams += allParams.join('&')
    }
    return returnedParams
  } catch (error) {
    return new Error(error)
  }
}

export default buildParamList
